import { Box } from "@mui/material"
import SometimeHint, { SometimeHintProps } from "../hints/SometimesHint"
import { HintRandomizerDto } from "../hints/HintsAutocomplete"
import { OotItemDto } from "../hints/OotItemAutocomplete"
import { isNil } from "lodash"


interface ReworkSometimesTrackerProps{
    top: number,
    left: number,
    hints: Array<SometimeHintProps>
    setHint: (hint: HintRandomizerDto | null, index: number) => void
    setState: (state: number, index: number) => void
    setItems: (item: OotItemDto |null, index: number, itemIndex: number) => void
    height?: number
}

const ReworkSometimesTracker = (props: ReworkSometimesTrackerProps) => {


    return <Box display="flex" position={"absolute"} flexDirection={"column"} top={props.top} left={props.left} flexWrap={"wrap"} height={isNil(props.height) ? 250: props.height}> 
        {props.hints.map((hint, i) => {
            return <SometimeHint {...hint} type={"sometimes"} setState={(e) => props.setState(e, i)} setHint={(h) => props.setHint(h ,i) } setHintItem={(item, ii) => props.setItems(item,i,ii)}/>
        })}
    </Box>
}

export default ReworkSometimesTracker